import React from 'react';

const SessionExpiredModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleCloseWindow = () => {
    window.close();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full mx-4 transform animate-pulse">
        <div className="text-center">
          {/* Warning Icon */}
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          
          {/* Title */}
          <h2 className="text-2xl font-bold text-red-800 mb-4">
            Session Expired!
          </h2>
          
          {/* Message */}
          <p className="text-gray-700 mb-8 leading-relaxed">
            Your booking session has expired. You cannot proceed with any booking operations. 
            Please close this window and start a new search.
          </p>
          
          {/* Close Window Button */}
          <button
            onClick={handleCloseWindow}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;